<template>
    <button
        class="text_align_btn tooltipElement"
        :class="[{ active: decorationValue }, `text_decoration-${decorationName}`]"
        @click="decorateText(decorationValue, decorationName)"
    >
        <inline-svg
            :src="decorateIcon"
            :fill="svgFillActive()"
        />
        <Tooltip :tooltipText="decorationName === 'capitals' ? `${ $t('editorSceneElementOptionsTextCapitalize') }` : `${ $t('editorSceneElementOptionsTextUnderline') }`" />
    </button>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Tooltip from '@/components/Global/Tooltip.vue';

    export default {
        data() {
            return {
                decorationValue: null
            }
        },
        methods: {
            decorateText(decorationValue, decorationName) {
                this.decorationValue = !this.decorationValue;
                let payload = {
                    variableName: decorationName,
                    value: !decorationValue
                }
                this.$store.dispatch('SET_TEXT_VARIABLE', payload)
            },
            svgFillActive() {
                return this.decorationValue ? `#${this.getSessionDetails.editorSetup.colors.primaryColor}` : '#707070'
            }
        },
        computed: {
            ...mapGetters([
                'activeElement',
                'getActiveElement',
                'getSessionDetails'
            ])
        },
        mounted() {
            this.decorationValue = this.getActiveElement.font[this.decorationName]
        },
        props: {
            decorationName: String,
            decorateIcon: String
        },
        components: {
            Tooltip
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .text_align_btn {
        background-color: #f5f5f5;
        border: none;
        cursor: pointer;
        display: flex;
        align-content: center;
        justify-content: center;
    }
</style>